export default __webpack_public_path__ + "static/rentvisie-logo-alt-1901e74524f0dfa65b7208e1c2618c09.webp";